"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Response = void 0;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class Response {
  constructor(data, code, errors, pagination) {
    _defineProperty(this, "_code", null);
    _defineProperty(this, "_data", null);
    _defineProperty(this, "_pagination", null);
    _defineProperty(this, "_errors", []);
    this._code = code || 200;
    this._data = data || null;
    this._errors = errors || [];
    this._pagination = pagination || null;
  }
  setCode(code) {
    this._code = code;
  }
  getCode(code) {
    return this._code || code;
  }
  setData(data) {
    this._data = data;
  }
  getData(data) {
    const _dataIsValid = !!this._data && Object.keys(this._data).length > 0;
    return _dataIsValid ? this._data : data;
  }
  setErrors(errors) {
    this._errors = errors;
  }
  getErrors(errors) {
    return this._errors || errors;
  }
  setErrors(errors) {
    this._errors = errors;
  }
  getErrors(errors) {
    return this._errors || errors;
  }
  setPagination(pagination) {
    this._pagination = pagination;
  }
  getPagination(pagination) {
    return this._pagination || pagination;
  }
  toJSON() {
    let response = {
      'code': this._code
    };
    if (this._data) {
      response.data = this._data;
    }
    if (this._errors) {
      response.errors = this._errors;
    }
    if (this._pagination) {
      response.pagination = this._pagination;
    }
    return {
      'response': response
    };
  }
}
exports.Response = Response;